module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view-report"
  }, [_c('div', {
    staticClass: "crumbs"
  }, [_c('span', [_vm._v("首页")]), _vm._v(">\n    "), _c('span', [_c('router-link', {
    attrs: {
      "to": {
        name: 'HospitalImage'
      }
    }
  }, [_vm._v("本院影像")])], 1), _vm._v(" >\n    "), _c('span', [_vm._v("查看报告")])]), _vm._v(" "), _c('div', {
    staticClass: "patient-report"
  }, [_c('div', {
    staticClass: "report-head"
  }, [_c('div', {
    staticClass: "report-info"
  }, [_c('b', [_vm._v(_vm._s(_vm.report.examTypeName) + "报告单")])]), _vm._v(" "), _c('div', {
    staticClass: "report-btn"
  }, _vm._l((_vm.btnTxts), function(btnTxt, index) {
    return _c('a', {
      class: {
        hui: index == 2 || index == 0
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.RepOperation(index)
        }
      }
    }, [_vm._v(_vm._s(btnTxt))])
  }), 0)]), _vm._v(" "), _c('reports', {
    attrs: {
      "info": _vm.report
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "list-num",
    on: {
      "click": function($event) {
        _vm.showHistory = !_vm.showHistory
      }
    }
  }, [_vm._v("历史检查：共查询到 "), _c('strong', [_vm._v(_vm._s(_vm.historyList))]), _vm._v(" 条信息 "), _c('i', {
    staticClass: "el-icon-arrow-down"
  })]), _vm._v(" "), _c('div', {
    staticClass: "history"
  }, [_c('el-collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showHistory),
      expression: "showHistory"
    }],
    staticClass: "historyList"
  }, [_c('div', {
    staticClass: "historyTable"
  }, [_c('tables', {
    staticClass: "history-table",
    attrs: {
      "readImageList": _vm.readImageList,
      "data": _vm.historyData,
      "showCheck": _vm.showCheck,
      "head": _vm.head
    },
    on: {
      "showDetial": _vm.showDetials,
      "readImg": _vm.readImgs
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "checkDetails"
  }, [_c('div', {
    staticClass: "DetailHead"
  }, [_c('span'), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentRow.examTypeName),
      expression: "currentRow.examTypeName"
    }]
  }, [_vm._v("\n              " + _vm._s(_vm.currentRow.examBodyName) + " / " + _vm._s(_vm.currentRow.examTypeName) + " / " + _vm._s(_vm.currentRow.studiesDoneDt))])]), _vm._v(" "), _c('div', {
    staticClass: "result-con"
  }, [_c('div', {
    staticClass: "Image"
  }, [_c('span', [_vm._v("影像所见：")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentRow != null),
      expression: "currentRow!=null"
    }],
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.currentRow.reportEvidences))])]), _vm._v(" "), _c('div', {
    staticClass: "Result"
  }, [_c('span', [_vm._v("诊断结果：")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentRow != null),
      expression: "currentRow!=null"
    }],
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.currentRow.reportConclusion))])])])])])])], 1), _vm._v(" "), _c('pops', {
    staticClass: "collect",
    attrs: {
      "show": _vm.pops,
      "width": _vm.popwidth,
      "title": _vm.title,
      "classes": 'Collections'
    },
    on: {
      "closePop": _vm.closePop
    }
  }, [_c('elcRep', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.popindex == 0),
      expression: "popindex==0"
    }],
    attrs: {
      "elcRep": _vm.elcRep,
      "emergent": _vm.emergent
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "shoucang"
    },
    slot: "shoucang"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.popindex == 4),
      expression: "popindex==4"
    }],
    staticClass: "record"
  }, [_c('div', {
    staticClass: "record-left"
  }, [(_vm.popindex == 4 && _vm.pops == true) ? _c('record', {
    attrs: {
      "tabs": _vm.tabs,
      "showCheckBox": true,
      "personList": _vm.personList,
      "treeData": _vm.treeData,
      "titleList": _vm.titleList,
      "filterText": _vm.filterText
    },
    on: {
      "tabChange": _vm.tabChange,
      "changeColl": _vm.changeColl,
      "delPerson": _vm.delPerson,
      "addPersonList": _vm.addPersonList,
      "searchClick": _vm.searchClick,
      "checkTree": _vm.checkTree,
      "personChecked": _vm.personChecked
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.popindex == 4 && _vm.pops == true) ? _c('div', {
    staticClass: "record-right"
  }, [_c('medicalNew', {
    attrs: {
      "info": _vm.CaseInfo
    },
    on: {
      "detailUpdate": _vm.CollectRecord
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.popindex == 4),
      expression: "popindex==4"
    }],
    attrs: {
      "slot": "shoucang-btn"
    },
    slot: "shoucang-btn"
  }, [_c('a', {
    staticClass: "shoucang",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.Collect
    }
  }, [_vm._v("收藏")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.popindex == 0),
      expression: "popindex==0"
    }],
    attrs: {
      "slot": "shoucang-btn"
    },
    slot: "shoucang-btn"
  }, [_c('a', {
    staticClass: "shoucang",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.closePop(false)
      }
    }
  }, [_vm._v("关闭")])])], 1), _vm._v(" "), _c('aycanImages', {
    ref: "aycanImages",
    attrs: {
      "isBenYuan": true,
      "hospitalId": _vm.params_image.hospitalId,
      "studyPk": _vm.params_image.studyPk,
      "studyUid": _vm.params_image.studyUid
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-bebbf6c6","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/moudle/hospitalImage/viewReport.vue
// module id = 601
// module chunks = 1 2 3 4 5 6 7 8